import { Component, OnInit } from '@angular/core';
import { NbSpinnerService,NbThemeService, NbMediaBreakpoint, NbMediaBreakpointsService } from '@nebular/theme';
import { AuthService } from '../../services/auth.service';
import { LoaderService } from '../../services/loader/loader.service';
import { Router } from '@angular/router';

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


	showMensagemSenha: boolean = false;
	mensagemSenha: string = "";
	style: any;
	login: any;
	showMessages: any;
	showLoginMessage:boolean = false;
	errors: any;
	messages: any;
	submitted: boolean;
	auth:AuthService;
	loginForm:boolean = true;
	loginMessage:string
	constructor(auth:AuthService, private loader:LoaderService, private router:Router) {

		this.auth = auth;
		this.loginMessage = "";
		this.showMessages = false;
		this.errors = [];
		this.messages = [];
		this.login = {};
		this.submitted = false;
	}

	ngOnInit() {
		NbSpinnerService.prototype.clear();
	}

	toggleEsqueciSenha(){
		this.loginForm = !this.loginForm;
	}

	esqueciSenha(){
		this.loader.show();
		this.auth.esqueciSenha(this.login).subscribe(data=>{
			this.showMensagemSenha = true;
			this.loader.hide();
			this.mensagemSenha = data["Mensagem"];
		});
	}
	logar () {
		this.loader.show();
		this.auth.login(this.login).subscribe(data => {
			this.loader.hide();
			
			if (data['Sucesso'] && data['Retorno'].Authenticated) {
                this.auth.setSession(data['Retorno']);                
			} else {

				this.loginMessage =  data['Mensagem'];
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/login/login/login.component.ts